import { apiConfig } from "./config";

export const commentApi = {
  list: async (replied: string, page: number, size: number) => {
    const response = await apiConfig.get(
      `/api/front/chef/comments/${replied}/${page}/${size}`
    );
    return response;
  },
  reply: async (orderId: any, repliedComment: any) => {
    const response = await apiConfig.post(`/api/front/chef/reply-comment`, {
      repliedComment: repliedComment,
      orderId: orderId,
    });
    return response;
  },
};
